
import Vue from "vue";
export default Vue.extend({
	props: {
		hide: Boolean,
		isWarning: Boolean
	}
});
